/* Pause all videos when an another video is playing */
document.querySelectorAll('video').forEach(video => {
  video.addEventListener('play', () => {
    document.querySelectorAll('video').forEach(otherVideo => {
      if (otherVideo !== video) otherVideo.pause();
    });
  });
});